// src/components/CustomersDataGrid.js

import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Chip, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import PendingIcon from '@mui/icons-material/Pending';

const CustomersDataGrid = ({ customers, loading, reportType, moduleId }) => {
  const navigate = useNavigate();

  const columns = [
    { field: 'slNo', headerName: 'Sl No', width: 80 },
    { field: 'customerName', headerName: 'Customer Name', width: 200 },
    { field: 'customerEmail', headerName: 'Email', width: 200 },
    { field: 'customerMobile', headerName: 'Mobile Number', width: 150 },
    { field: 'customerPincode', headerName: 'Pincode', width: 100 },
    { field: 'customerDistrictName', headerName: 'District', width: 150 },
    { field: 'customerTalukName', headerName: 'CONSTITUENCY', width: 150 },
    {
      field: 'acemoneySync',
      headerName: 'AceMoney Status',
      width: 180,
      renderCell: (params) => {
        const { acemoneySynced, acemoneySyncError, customerVPA } = params.row;

        // No VPAs - show N/A
        if (!customerVPA || customerVPA.length === 0) {
          return (
            <Chip
              label="No VPA"
              size="small"
              color="default"
              variant="outlined"
            />
          );
        }

        // Has error
        if (acemoneySyncError) {
          return (
            <Tooltip title={acemoneySyncError} arrow>
              <Chip
                icon={<ErrorIcon />}
                label="Sync Error"
                size="small"
                color="error"
              />
            </Tooltip>
          );
        }

        // Synced successfully
        if (acemoneySynced) {
          return (
            <Chip
              icon={<CheckCircleIcon />}
              label="Synced"
              size="small"
              color="success"
            />
          );
        }

        // Not synced yet
        return (
          <Chip
            icon={<PendingIcon />}
            label="Pending"
            size="small"
            color="warning"
          />
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderCell: (params) => {
        // Determine the button label based on reportType
        let buttonLabel = 'View Report';
        let navigatePath = `/customer-report/${reportType}/${params.row.customerId}`;

        if (reportType === 'welfare-amount' || reportType === 'reduce-welfare') {
          buttonLabel = 'Manage Welfare';
          navigatePath = `/customer-report/${reportType}/${params.row.customerId}`;
        } else if (reportType === 'vpa-search') {
          buttonLabel = 'VPA Details';
          navigatePath = `/customer-report/${reportType}/${params.row.customerId}`;
        }

        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleActionButtonClick(params.row, navigatePath)}
          >
            {buttonLabel}
          </Button>
        );
      },
    },
  ];

  const handleActionButtonClick = (row, path) => {
    // Navigate to the detailed report page for the customer
    navigate(path, {
      state: { moduleId },
    });
  };

  const rows = customers.map((customer, index) => ({
    id: index,
    slNo: index + 1,
    customerId: customer.customerId, // Include customerId here
    customerName: customer.customerName,
    customerEmail: customer.customerEmail || 'N/A',
    customerMobile: customer.customerMobile,
    customerPincode: customer.customerPincode,
    customerDistrictName: customer.customerDistrictName || 'N/A',
    customerTalukName: customer.customerTalukName || 'N/A',
    customerVPA: customer.customerVPA || [],
    acemoneySynced: customer.acemoneySynced || false,
    acemoneySyncError: customer.acemoneySyncError || null,
  }));

  return (
    <div style={{ width: '100%', marginTop: 20 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        pageSize={25}
        rowsPerPageOptions={[25]}
        disableSelectionOnClick
        autoHeight
      />
    </div>
  );
};

export default CustomersDataGrid;
